/**
 * What a hover marks in the panel (`data-map-hover`): every element standing for the ports or routes focused
 * (`data-map-port`, a port's slug; `data-map-routes`, route ids), the stop list's dots, names and lines and the
 * operators' rows alike. A row of a list under the mouse (`data-map-row`: a destination, a port, an operator's block,
 * one of its lines) is marked alone of the rows, the rows sharing its lines lighting up reading as a bug; a hover on
 * the map marks them all, and the route page's stop list (its dots, lines and names, links though they are) still
 * lights with the row.
 */

/** Whether a panel element is a row of a list, rather than a part of a drawing like the stop list. */
export const isRow = (el: HTMLElement) => el.hasAttribute('data-map-row');

/** Mark in `panel` the elements standing for these ports or routes, and only them; the row hovered (`row`) alone of the rows. */
export function markPanel(panel: HTMLElement, ports: Set<string>, ids: number[], row: HTMLElement | null): void {
  const routes = new Set(ids);
  for (const el of panel.querySelectorAll('[data-map-hover]')) el.removeAttribute('data-map-hover');
  row?.setAttribute('data-map-hover', '');
  const marks = (el: HTMLElement) => !(row && isRow(el));
  for (const el of panel.querySelectorAll<HTMLElement>('[data-map-port]'))
    if (marks(el) && ports.has(el.dataset.mapPort!)) el.setAttribute('data-map-hover', '');
  for (const el of panel.querySelectorAll<HTMLElement>('[data-map-routes]'))
    if (marks(el) && el.dataset.mapRoutes!.split(' ').some((id) => routes.has(Number(id)))) el.setAttribute('data-map-hover', '');
}
